import { FC } from 'react';
import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { colors } from 'styles/colors';

import {
  ArrowWrapper,
  FirstSectionDescription,
  FirstSectionTitle,
  FirstSectionWrapper,
  ItemsWrapper,
  ItemWrapper,
} from './InformationBlock.styles';

import ArrowDownImage from 'assets/customer-cases/arrow-down.webp';

import { IInformationBlockData } from 'types/customer-case';
import { HeroSection } from 'components/HeroSection';
import { LeftTriangleTop, RightTriangleTop } from 'components/HeroSection/HeroSection.styles';
import { useNavigate } from 'react-router-dom';

interface IInformationBlockProps {
  data: IInformationBlockData;
  isFirstSection?: boolean;
  showArrow?: boolean;
}

export const InformationBlock: FC<IInformationBlockProps> = ({
  data,
  showArrow,
  isFirstSection,
}) => {
  const { title, description, items, link, linkLabel } = data;
  const navigate = useNavigate();

  return (
    <Box
      position="relative"
      padding={{
        md: showArrow ? '155px 0 200px' : '155px 0 0',
        xxs: showArrow ? '155px 0 152px' : '155px 0 0',
      }}
      width="100%"
    >
      <Box position="relative">
        <LeftTriangleTop />
        <RightTriangleTop />
      </Box>

      <HeroSection>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="100%"
          maxWidth="1200px"
          padding={{
            md: isFirstSection ? '120px 24px 244px 24px' : '120px 24px 184px 24px',
            xxs: '80px 24px 107px 24px',
          }}
        >
          <FirstSectionWrapper>
            <FirstSectionTitle>{title}</FirstSectionTitle>

            <FirstSectionDescription>{description}
            <br />
            {linkLabel && link && (
              <Typography
                component="span"
                fontSize="16px"
                fontWeight={700}
                lineHeight="150%"
                color={colors.white}
                marginTop="24px"
                sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                onClick={() => navigate(link)}
              >
                {linkLabel} &gt;
              </Typography>
            )}
            </FirstSectionDescription>
          </FirstSectionWrapper>

          <ItemsWrapper>
            {items.map((item) => (
              <ItemWrapper key={item.title} itemsCount={items.length}>
                <Box
                  sx={{
                    '& img': {
                      display: 'block',
                    },
                  }}
                >
                  <img src={item.Icon} alt={item.title} />
                </Box>

                <Typography
                  margin={{
                    md: '24px 0',
                    xxs: '16px 0',
                  }}
                  fontSize="20px"
                  lineHeight="140%"
                  fontWeight={700}
                  color={colors.white}
                  whiteSpace="pre-line"
                >
                  {item.title}
                </Typography>

                <Typography
                  fontSize="16px"
                  lineHeight="150%"
                  color={colors.white}
                  whiteSpace="pre-line"
                >
                  {item.description}
                </Typography>
              </ItemWrapper>
            ))}
          </ItemsWrapper>
        </Box>
      </HeroSection>

      {showArrow && (
        <ArrowWrapper>
          <img src={ArrowDownImage} alt="arrow down" />
        </ArrowWrapper>
      )}
    </Box>
  );
};
